import { render } from "./ShipTourLanding.vue?vue&type=template&id=8bb2ce2c"
import script from "./ShipTourLanding.vue?vue&type=script&lang=js"
export * from "./ShipTourLanding.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__